// extracted by mini-css-extract-plugin
module.exports = {"imageQuestion":"QTImage_imageQuestion__lSGCd","error":"QTImage_error__NiB8Z","interactive":"QTImage_interactive__xuOUh","successMessage":"QTImage_successMessage__Nghm4"};